/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { OverlayRef } from '@angular/cdk/overlay';

export class LineIsolationListOverlayRef {
    constructor(
        private overlayRef: OverlayRef,
    ) {}

    public close(): void {
        this.overlayRef.dispose();
    }
}
